import type { Message } from "@/redux/modules/value/messages/messages.utils";
import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";

const successMessage: () => Message = () => ({
    id: "bonuscard-feedback-success",
    text: translateWithoutContext("account.bonusCard.add.feedback.success"),
    status: "success",
    dismissible: true
});

const failureMessage: (tk?: string) => Message = (tk) => ({
    id: "bonuscard-feedback-failure",
    text: tk
        ? translateWithoutContext(
              `general.form.input.validation.bonusCard.${tk}`
          )
        : translateWithoutContext("account.bonusCard.add.feedback.failure"),
    status: "warning",
    dismissible: true
});

const removeSuccessMessage: () => Message = () => ({
    id: "bonuscard-feedback-success",
    text: translateWithoutContext("account.bonusCard.remove.feedback.success"),
    status: "success",
    dismissible: true
});

const removeFailureMessage: () => Message = () => ({
    id: "bonuscard-feedback-failure",
    text: translateWithoutContext("account.bonusCard.remove.feedback.failure"),
    status: "warning",
    dismissible: true
});

export {
    failureMessage,
    removeFailureMessage,
    removeSuccessMessage,
    successMessage
};
